export const getRiyadhISOString = () => {
    const now = new Date();
    const isoString = now.toISOString();
    return isoString;
}